module.exports = __webpack_public_path__ + "static/img/Cine-Pass.f1d8c21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisingImagesNew/Cine-Pass.jpg
// module id = In2c
// module chunks = 11